import {
  createObservableAndState,
  ObservableAndState,
} from '@provider-portal/common/utils/observable_and_state';
import { Observable } from 'rxjs';
import type { Store } from 'redux';

import { GlobalAppState } from '../rdx/state';

export type GlobalStoreAdapterFunction<T> = (store: GlobalAppState) => T;

export const createObservableAndStateFromGlobalStore = <T>(
  globalStore: Store,
  adapterFct: GlobalStoreAdapterFunction<T> = null,
  initialCommit: boolean = true,
): ObservableAndState<T> => {
  const adaptedObservable = new Observable<T>((subscriber) => {
    if (initialCommit) {
      subscriber.next(adapterFct(globalStore.getState()));
    }

    globalStore.subscribe(() => {
      subscriber.next(adapterFct(globalStore.getState()));
    });
  });
  const adaptedState = adapterFct(globalStore.getState());

  return createObservableAndState<T>(adaptedObservable, adaptedState);
};
